// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import {
//   Card,
//   Box,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Button,
//   Chip,
//   IconButton,
//   CircularProgress,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import SoftButton from "components/SoftButton";
// import { Download, Upload, Refresh } from "@mui/icons-material";
// import {
//   getSalaryMonths,
//   getCalculatedSalaries,
//   downloadSalaryReport,
//   uploadSalaryData,
// } from "api/salary";
// import DataTable from "examples/Tables/DataTable";

// // ✅ StatusChip component for DataTable
// const StatusChip = ({ value, row, getStatusColor }) => (
//   <Chip
//     label={value}
//     color={getStatusColor(row.original.status)}
//     size="small"
//     variant="outlined"
//   />
// );

// StatusChip.propTypes = {
//   value: PropTypes.string,
//   row: PropTypes.shape({
//     original: PropTypes.shape({
//       status: PropTypes.string,
//     }),
//   }),
//   getStatusColor: PropTypes.func.isRequired,
// };

// const SalaryManual = () => {
//   const [salaryMonths, setSalaryMonths] = useState([]);
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [salaryData, setSalaryData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   useEffect(() => {
//     fetchSalaryMonths();
//   }, []);

//   const fetchSalaryMonths = async () => {
//     try {
//       setLoading(true);
//       const response = await getSalaryMonths();
//       if (response && response.success) {
//         const months = response.data || [];
//         setSalaryMonths(months);

//         if (months.length > 0) {
//           const firstMonth = months[0].value;
//           setSelectedMonth(firstMonth);
//           await fetchSalaryData(firstMonth);
//         } else {
//           setSelectedMonth("");
//           setSalaryData([]);
//         }
//       } else {
//         setError("Failed to fetch salary months");
//       }
//     } catch (error) {
//       setError("Error fetching salary months: " + (error.message || "Unknown error"));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSalaryData = async (monthValue) => {
//     if (!monthValue) return;
//     setLoading(true);
//     try {
//       const response = await getCalculatedSalaries(monthValue);
//       if (response && response.success) {
//         setSalaryData(response.data || []);
//         setError("");
//       } else {
//         setError("Failed to fetch salary data");
//         setSalaryData([]);
//       }
//     } catch (error) {
//       setError("Error fetching salary data: " + (error.message || "Unknown error"));
//       setSalaryData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleMonthChange = async (event) => {
//     const newMonth = event.target.value;
//     setSelectedMonth(newMonth);
//     await fetchSalaryData(newMonth);
//   };

//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     if (!file.name.match(/\.(xlsx|xls)$/)) {
//       setError("Please upload an Excel file (.xlsx or .xls)");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     setUploading(true);
//     try {
//       const response = await uploadSalaryData(formData);
//       if (response && response.success) {
//         setSuccess(response.message || "Salary data uploaded successfully!");
//         setTimeout(() => {
//           fetchSalaryMonths();
//         }, 1000);
//       } else {
//         setError(response?.message || "Failed to upload salary data");
//       }
//     } catch (error) {
//       setError("Error uploading salary data: " + (error.message || "Unknown error"));
//     } finally {
//       setUploading(false);
//       event.target.value = "";
//     }
//   };

//   const handleDownloadReport = async () => {



//     if (!selectedMonth) {
//       setError("Please select a month first");
//       return;
//     }

//     try {
//       const response = await downloadSalaryReport(selectedMonth);

//       if (response && response.success) {
//         const dataStr = JSON.stringify(response.data, null, 2);
//         const blob = new Blob([dataStr], { type: "application/json" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = salary-report-${selectedMonth}.json;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//         setSuccess("Salary report downloaded successfully!");
//       } else {
//         setError("Failed to download salary report");
//       }
//     } catch (error) {
//       setError("Error downloading report: " + (error.message || "Unknown error"));
//     }
//   };

//   const handleRefresh = () => {
//     if (selectedMonth) fetchSalaryData(selectedMonth);
//     else fetchSalaryMonths();
//   };

//   const handleCloseSnackbar = () => {
//     setError("");
//     setSuccess("");
//   };

//   const getStatusColor = (status) => {
//     if (!status) return "default";
//     switch (status.toLowerCase()) {
//       case "approved":
//         return "success";
//       case "rejected":
//         return "error";
//       case "pending":
//         return "warning";
//       default:
//         return "default";
//     }
//   };

//   const formatCurrency = (amount) => {
//     if (amount === null || amount === undefined) return "₹0";
//     const num = parseFloat(amount);
//     return `₹${isNaN(num)
//       ? "0"
//       : num.toLocaleString("en-IN", {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         })}`;
//   };

//   const getTableData = () => {
//     const columns = [
//       { Header: "Employee Code", accessor: "employee_code", width: "15%" },
//       { Header: "Employee Name", accessor: "employee_name", width: "20%" },
//       {
//         Header: "Salary Days",
//         accessor: "salary_days_display",
//         width: "15%",
//         Cell: ({ value }) => value || "0/0"
//       },
//       { Header: "Earned Total", accessor: "earned_total_formatted", width: "15%" },
//       { Header: "Deductions", accessor: "total_deduction_formatted", width: "15%" },
//       { Header: "Net Payable", accessor: "net_payable_formatted", width: "15%" },
//       { Header: "Final Salary", accessor: "final_salary_formatted", width: "15%" },
//      {
//   Header: "Status",
//   accessor: "status_display",
//   width: "15%",
//   // eslint-disable-next-line react/prop-types
//   Cell: ({ value, row }) => (
//     <StatusChip value={value} row={row} getStatusColor={getStatusColor} />
//   ),
// },

//     ];

//     const rows = salaryData.map((salary, index) => ({
//       ...salary,
//       id: ${salary.employee_code}-${index},
//       salary_days_display: ${salary.salary_days || 0}/${salary.total_days_in_month || 30},
//       earned_total_formatted: formatCurrency(salary.earned_total),
//       total_deduction_formatted: formatCurrency(salary.total_deduction),
//       net_payable_formatted: formatCurrency(salary.net_payable),
//       final_salary_formatted: formatCurrency(salary.final_salary),
//       status_display: (salary.status || "draft").toUpperCase(),
//     }));

//     return { columns, rows };
//   };

//   const tableData = getTableData();

//   return (
//     <Card sx={{ p: 3, borderRadius: 3, minHeight: 600 }}>
//       <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseSnackbar}>
//         <Alert onClose={handleCloseSnackbar} severity="error">
//           {error}
//         </Alert>
//       </Snackbar>
//       <Snackbar open={!!success} autoHideDuration={4000} onClose={handleCloseSnackbar}>
//         <Alert onClose={handleCloseSnackbar} severity="success">
//           {success}
//         </Alert>
//       </Snackbar>

//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//         <Typography variant="h5" fontWeight="bold">
//           Salary Manual
//         </Typography>

//         <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
//           <IconButton onClick={handleRefresh} disabled={loading} color="primary" title="Refresh Data">
//             <Refresh />
//           </IconButton>

//           <FormControl size="small" sx={{ minWidth: 200 }}>
//             {/* <InputLabel id="month-select-label">Select Month</InputLabel> */}
//             <Select
//               labelId="month-select-label"
//               value={selectedMonth}
//               label="Select Month"
//               onChange={handleMonthChange}
//               disabled={salaryMonths.length === 0}
//             >
//               {salaryMonths.map((month) => (
//                 <MenuItem key={month.value} value={month.value}>
//                   {month.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <SoftButton
//             variant="outlined"
//             component="label"
//              color="info"
//             startIcon={uploading ? <CircularProgress size={16} /> : <Upload />}
//             disabled={uploading}
//             sx={{ minWidth: 140 }}
//           >
//             {uploading ? "Uploading..." : "Upload Excel"}
//             <input type="file" accept=".xlsx,.xls" hidden onChange={handleFileUpload} disabled={uploading} />
//           </SoftButton>

//           <SoftButton
//             variant="gradient"
//             color="info"
//             startIcon={<Download />}
//             onClick={handleDownloadReport}
//             disabled={!selectedMonth || loading}
//             sx={{ minWidth: 160 }}
//           >
//             Download Report
//           </SoftButton>
//         </Box>
//       </Box>

//       <Box mb={2} p={1} bgcolor="grey.50" borderRadius={1}>
//         <Typography variant="body2" color="textSecondary">
//           📊 <strong>Status:</strong>{" "}
//           {salaryMonths.length === 0
//             ? "📝 Upload Excel file to get started"
//             : !selectedMonth
//             ? "📅 Select a month to view data"
//             : `✅ Viewing data for ${
//                 salaryMonths.find((m) => m.value === selectedMonth)?.label || selectedMonth
//               }`}{" "}
//           | Available Months: {salaryMonths.length} | Records: {salaryData.length}
//         </Typography>
//       </Box>

//       {loading && (
//         <Box display="flex" justifyContent="center" alignItems="center" py={8}>
//           <CircularProgress />
//           <Typography variant="body1" sx={{ ml: 2 }}>
//             {selectedMonth ? "Loading salary data..." : "Loading months..."}
//           </Typography>
//         </Box>
//       )}

//       {!loading && salaryData.length > 0 && (
//         <DataTable
//           table={tableData}
//           entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
//           // canSearch={true}
//           showTotalEntries={true}
//           isSorted={true}
//           noEndBorder={false}
//           pagination={{ variant: "gradient", color: "info" }}
//         />
//       )}

//       {!loading && salaryData.length === 0 && selectedMonth && (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           py={8}
//           bgcolor="grey.50"
//           borderRadius={2}
//         >
//           <Typography variant="body1" color="textSecondary">
//             📝 No salary data found for{" "}
//             {salaryMonths.find((m) => m.value === selectedMonth)?.label || selectedMonth}
//           </Typography>
//         </Box>
//       )}

//       {!loading && !selectedMonth && salaryMonths.length === 0 && (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           py={8}
//           bgcolor="grey.50"
//           borderRadius={2}
//         >
//           <Typography variant="body1" color="textSecondary">
//             📊 Upload an Excel file to get started with salary data
//           </Typography>
//         </Box>
//       )}
//     </Card>
//   );
// };

// export default SalaryManual;

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Card,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import { Download, Upload, Refresh } from "@mui/icons-material";
import {
  getSalaryMonths,
  getCalculatedSalaries,
  downloadSalaryReport,
  uploadSalaryData,
} from "api/salary";
import DataTable from "examples/Tables/DataTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// ✅ StatusChip component for DataTable
const StatusChip = ({ value, row, getStatusColor }) => (
  <Chip label={value} color={getStatusColor(row.original.status)} size="small" variant="outlined" />
);

StatusChip.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      status: PropTypes.string,
    }),
  }),
  getStatusColor: PropTypes.func.isRequired,
};

const SalaryManual = () => {
  const [salaryMonths, setSalaryMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [salaryData, setSalaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [downloading, setDownloading] = useState(false);


  useEffect(() => {
    fetchSalaryMonths();
  }, []);

  const fetchSalaryMonths = async () => {
    try {
      setLoading(true);
      const response = await getSalaryMonths();
      console.log("✅ Salary months API response:", response);

      if (response && response.success) {
        const months = response.data || [];
        setSalaryMonths(months);

        if (months.length > 0) {
          const firstMonth = months[0].value;
          setSelectedMonth(firstMonth);
          console.log("✅ Default month set to:", firstMonth);
          await fetchSalaryData(firstMonth);
        } else {
          setSelectedMonth("");
          setSalaryData([]);
        }
      } else {
        setError("Failed to fetch salary months");
      }
    } catch (error) {
      console.error("❌ Error fetching salary months:", error);
      setError("Error fetching salary months: " + (error.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const fetchSalaryData = async (monthValue) => {
    if (!monthValue) return;

    setLoading(true);
    try {
      console.log("🔄 Fetching salary data for month:", monthValue);
      const response = await getCalculatedSalaries(monthValue);
      console.log("✅ Salary data API response:", response);

      if (response && response.success) {
        setSalaryData(response.data || []);
        console.table(response.data);
        setError("");
      } else {
        setError("Failed to fetch salary data");
        setSalaryData([]);
      }
    } catch (error) {
      console.error("❌ Error fetching salary data:", error);
      setError("Error fetching salary data: " + (error.message || "Unknown error"));
      setSalaryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMonthChange = async (event) => {
    const newMonth = event.target.value;
    console.log("📅 Month changed to:", newMonth);
    setSelectedMonth(newMonth);
    await fetchSalaryData(newMonth);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      setError("Please upload an Excel file (.xlsx or .xls)");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    try {
      console.log("📤 Uploading file:", file.name);
      const response = await uploadSalaryData(formData);
      console.log("✅ Upload API response:", response);

      if (response && response.success) {
        setSuccess(response.message || "Salary data uploaded successfully!");
        setTimeout(() => {
          fetchSalaryMonths();
        }, 1000);
      } else {
        setError(response?.message || "Failed to upload salary data");
      }
    } catch (error) {
      console.error("❌ Error uploading salary data:", error);
      setError("Error uploading salary data: " + (error.message || "Unknown error"));
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  };

  // const handleDownloadReport = async () => {
  //   if (!selectedMonth) {
  //     setError("Please select a month first");
  //     return;
  //   }

  //   try {
  //     console.log("📥 Downloading report for month:", selectedMonth);
  //     const response = await downloadSalaryReport(selectedMonth);

  //     if (response && response.success) {
  //       const dataStr = JSON.stringify(response.data, null, 2);
  //       const blob = new Blob([dataStr], { type: "application/json" });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = salary-report-${selectedMonth}.json;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(url);
  //       setSuccess("Salary report downloaded successfully!");
  //     } else {
  //       setError("Failed to download salary report");
  //     }
  //   } catch (error) {
  //     console.error("❌ Error downloading report:", error);
  //     setError("Error downloading report: " + (error.message || "Unknown error"));
  //   }
  // };

  const handleDownloadReport = async () => {
    if (!selectedMonth) {
      setError("Please select a month first");
      return;
    }

 setDownloading(true)

    try {
      console.log("📥 Downloading report for month:", selectedMonth);

      // ✅ Call the API — make sure your backend sets responseType: 'blob' in axios
      const response = await downloadSalaryReport(selectedMonth);

      if (response) {
        // If you are using axios, the binary data will be in response.data
        const blob = new Blob([response.data], {
          type:
            response.headers?.["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `salary-report-${selectedMonth}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setSuccess("✅ Salary report downloaded successfully!");
      } else {
        setError("Failed to download salary report");
      }
    } catch (error) {
      console.error("❌ Error downloading report:", error);
      setError("Error downloading report: " + (error.message || "Unknown error"));
    } finally {
    setDownloading(false); // 👈 reset after success/fail
  }
  };

  const handleRefresh = () => {
    if (selectedMonth) fetchSalaryData(selectedMonth);
    else fetchSalaryMonths();
  };

  const handleCloseSnackbar = () => {
    setError("");
    setSuccess("");
  };

  const getStatusColor = (status) => {
    if (!status) return "default";
    switch (status.toLowerCase()) {
      case "approved":
        return "success";
      case "rejected":
        return "error";
      case "pending":
        return "warning";
      default:
        return "default";
    }
  };

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "₹0";
    const num = parseFloat(amount);
    return `₹${
      isNaN(num)
        ? "0"
        : num.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
    }`;
  };

  const getTableData = () => {
    const columns = [
      { Header: "Employee Code", accessor: "employee_code", width: "12%" },
      { Header: "Employee Name", accessor: "employee_name", width: "18%" },
      {
        Header: "Salary Days",
        accessor: "salary_days_display",
        width: "12%",
        Cell: ({ value }) => value || "0/0",
      },
      {
        Header: "Basic",
        accessor: "earned_basic_formatted",
        width: "12%",
      },
      {
        Header: "HRA",
        accessor: "earned_hra_formatted",
        width: "12%",
      },
      {
        Header: "Earned Total",
        accessor: "earned_total_formatted",
        width: "12%",
      },
      {
        Header: "Deductions",
        accessor: "total_deduction_formatted",
        width: "12%",
      },
      {
        Header: "Net Payable",
        accessor: "net_payable_formatted",
        width: "12%",
      },
      {
        Header: "Final Salary",
        accessor: "final_salary_formatted",
        width: "12%",
      },
    ];

    const rows = salaryData.map((salary, index) => ({
      ...salary,
      id: `${salary.employee_code}-${index}`,
      salary_days_display: `${salary.salary_days || 0}/${salary.total_days_in_month || 30}`,
      earned_basic_formatted: formatCurrency(salary.earned_basic),
      earned_hra_formatted: formatCurrency(salary.earned_hra),
      earned_total_formatted: formatCurrency(salary.earned_total),
      total_deduction_formatted: formatCurrency(salary.total_deduction),
      net_payable_formatted: formatCurrency(salary.net_payable),
      final_salary_formatted: formatCurrency(salary.final_salary),
      status_display: (salary.status || "draft").toUpperCase(),
    }));

    return { columns, rows };
  };

  const tableData = getTableData();

  return (
    <Card sx={{ p: 3, borderRadius: 3, minHeight: 600 }}>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={!!success} autoHideDuration={4000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="success">
          {success}
        </Alert>
      </Snackbar>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Salary Manual
        </Typography>

        <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
          <IconButton
            onClick={handleRefresh}
            disabled={loading}
            color="primary"
            title="Refresh Data"
          >
            <Refresh />
          </IconButton>

          <FormControl size="small" sx={{ minWidth: 200 }}>
            <Select
              labelId="month-select-label"
              value={selectedMonth}
              label="Select Month"
              onChange={handleMonthChange}
              disabled={salaryMonths.length === 0}
            >
              {salaryMonths.map((month) => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <SoftButton
            variant="outlined"
            component="label"
            color="info"
            startIcon={uploading ? <CircularProgress size={16} /> : <Upload />}
            disabled={uploading}
            sx={{ minWidth: 140 }}
          >
            {uploading ? "Uploading..." : "Upload Excel"}
            <input
              type="file"
              accept=".xlsx,.xls"
              hidden
              onChange={handleFileUpload}
              disabled={uploading}
            />
          </SoftButton>

<SoftButton
  variant="gradient"
  color="info"
  startIcon={<Download />}
  onClick={handleDownloadReport}
  disabled={!selectedMonth}
  sx={{ minWidth: 160 }}
>
  {downloading ? "Downloading..." : "Download Report"}
</SoftButton>



        </Box>
      </Box>

      <Box mb={2} p={1} bgcolor="grey.50" borderRadius={1}>
        <Typography variant="body2" color="textSecondary">
          📊 <strong>Status:</strong>{" "}
          {salaryMonths.length === 0
            ? "📝 Upload Excel file to get started"
            : !selectedMonth
            ? "📅 Select a month to view data"
            : `✅ Viewing data for ${
                salaryMonths.find((m) => m.value === selectedMonth)?.label || selectedMonth
              }`}{" "}
          | Available Months: {salaryMonths.length} | Records: {salaryData.length}
        </Typography>
      </Box>

      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" py={8}>
          <CircularProgress />
          <Typography variant="body1" sx={{ ml: 2 }}>
            {selectedMonth ? "Loading salary data..." : "Loading months..."}
          </Typography>
        </Box>
      )}

      {!loading && salaryData.length > 0 && (
        <DataTable
          table={tableData}
          entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
          canSearch={true}
          showTotalEntries={true}
          isSorted={true}
          noEndBorder={false}
          pagination={{ variant: "gradient", color: "info" }}
        />
      )}

      {!loading && salaryData.length === 0 && selectedMonth && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          py={8}
          bgcolor="grey.50"
          borderRadius={2}
        >
          <Typography variant="body1" color="textSecondary">
            📝 No salary data found for{" "}
            {salaryMonths.find((m) => m.value === selectedMonth)?.label || selectedMonth}
          </Typography>
        </Box>
      )}

      {!loading && !selectedMonth && salaryMonths.length === 0 && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          py={8}
          bgcolor="grey.50"
          borderRadius={2}
        >
          <Typography variant="body1" color="textSecondary">
            📊 Upload an Excel file to get started with salary data
          </Typography>
        </Box>
      )}
    </Card>
  );
};

// PropTypes for SalaryManual component
SalaryManual.propTypes = {
  // Note: Since this is the main component, it typically doesn't receive props
  // But if it does, define them here
};

export default SalaryManual;